// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f1207cd5","787":"ae8140ad"}[chunkId] + ".chunk.js";
};